const EVENT = {
  ACCORDION: {
    DRAWER: {
      CLOSED: 'accordion-drawer:closed',
    },
  },
  CART: {
    UPDATE: 'cart:update',
  },
  CONFIRM: {
    CANCELLED: 'confirm:cancelled',
    CONFIRMED: 'confirm:confirmed',
    OPENED: 'confirm:opened',
    TOGGLE: 'confirm:toggle',
  },
  DRAWER: {
    OPEN: 'drawer:open',
    CLOSE: 'drawer:close',
    TOGGLE: 'drawer:toggle',
  },
  MODAL: {
    OPEN: 'modal:open',
    CLOSE: 'modal:close',
    TOGGLE: 'modal:toggle',
  },
  OVERLAY: {
    DEACTIVATE: 'overlay:deactivate',
    ACTIVATE: 'overlay:activate',
  },
  SUBSCRIPTION: {
    OPTION: {
      SELECTED: 'option:selected',
    },
    SELECTOR: {
      SELECTED: 'selector:selected',
    },
  },
};

export default EVENT;
